var isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

$(document).ready(function() {
 
  $window = $(window);
  
  // Sticky menu
  
  	$("nav.nav-bar").sticky({ topSpacing: 0 });
  
  // Sticky menu
  
  	$("nav.botones").sticky({ topSpacing: 0 });
 
 
  
   // Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top -90
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
  
  
  // Owl carousel products carousel
  $(".product-carousel").owlCarousel({
    items : 4,
    itemsDesktop : [1000,4],
    itemsDesktopSmall : [960,3],
    itemsTablet: [748,2], 
    itemsMobile : [480,1],
    navigation: true,
    navigationText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>"
      ],
    pagination: false,
    autoPlay: false
  });
  
  // Owl sidebar products carousel
  $(".product-carousel-sidebar").owlCarousel({
    items : 1,
    itemsDesktop : [1000,1],
    itemsDesktopSmall : [960,1],
    itemsTablet: [748,1], 
    itemsMobile : [480,1],
    navigation: true,
    navigationText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>"
      ],
    pagination: false,
    autoPlay: false
  });
    
  
  // Owl carousel featured product carousel
  $(".featured-product-carousel").owlCarousel({
    items:1,
    itemsDesktop : [1000,1],
    itemsDesktopSmall : [960,1],
    itemsTablet: [748,1], 
    itemsMobile : [480,1],
    navigation: true,
    navigationText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>"
      ],
    pagination: false,
    autoPlay: true
  });
   // Owl carousel Negocios
  $(".negocios").owlCarousel({
    items : 1,
    itemsDesktop : [1000,1],
    itemsDesktopSmall : [960,1],
    itemsTablet: [748,1], 
    itemsMobile : [480,1],
    navigation: true,
    navigationText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>"
      ],
    pagination: false,
    autoPlay: true,
    speed:700
  });
  
  // Accordion
  function close_accordion_section() {
    $('.accordion .accordion-section-title').removeClass('active');
    $('.accordion .accordion-section-content').slideUp(300).removeClass('open');
  }

  $('.accordion-section-title').click(function(e) {
    // Grab current anchor value
    var currentAttrValue = $(this).attr('href');

    if($(e.target).is('.active')) {
      close_accordion_section();
    }else {
      close_accordion_section();

      // Add active class to section title
      $(this).addClass('active');
      // Open up the hidden content panel
      $('.accordion ' + currentAttrValue).slideDown(300).addClass('open'); 
    }

    e.preventDefault();
  });
  
  // DOM Handlers
  $(window).resize( function(){
    
      adjust_mega_menu();
    
    adjust_carousel_products_height();
    adjust_collection_products_details_height();
  });
  
  // On document load
  
    adjust_mega_menu();
  
  
  setTimeout(adjust_carousel_products_height,200);
  adjust_collection_products_details_height();
  
  
  
});


// Adjust carousel products height
adjust_carousel_products_height = function(){
  $('.product-carousel').each(function(){
  	
    var tallestItem = 0;
    
    $(this).find('.owl-item__image').each(function(i, val){
      tallestItem = $(val).height() > tallestItem ? $(val).height() : tallestItem;
    });
    
    $(this).find('.owl-item__image').each(function(i, val){
      $(val).height(tallestItem);
    });
    
  });
}

// Adjust collection products details height
adjust_collection_products_details_height = function(){
  var tallestItem = 0;
  $('.item-product__details').height('auto');
  $('.item-product__details').each(function(i, val){
    tallestItem = $(val).height() > tallestItem ? $(val).height() : tallestItem;
  });
  $('.item-product__details').each(function(i, val){
    $(val).height(tallestItem);
  }); 
}


  // Adjust mega menu position
  adjust_mega_menu = function(){
    $('.site-nav__mega-menu').css('left',( -1 *  $('.site-nav--has-megamenu').position().left) - 30);
    $('.site-nav__mega-menu').width( $('nav.nav-bar').width() - 40);
  }


// Replace standar logo with retina version
